/**
 * Mirrored from `cosmo-bud-portal-backend/src/modules/parents/dto/parent-profile.schemas.ts`.
 * Drift is enforced by `scripts/diff-schemas.mjs` in CI — never edit one side
 * without the other.
 *
 * GRADE_LEVELS duplicated from the tutors constants (same domain value set).
 */
import { z } from 'zod';
import { GRADE_LEVELS } from './tutor-profile';

export { GRADE_LEVELS };
export type GradeLevel = (typeof GRADE_LEVELS)[number];

export const AddChildSchema = z.object({
  name: z.string().trim().min(1).max(120),
  age: z.number().int().min(1).max(25),
  grade: z.enum(GRADE_LEVELS),
  notes: z.string().trim().max(500).nullable().optional().default(null),
});
export type AddChildInput = z.infer<typeof AddChildSchema>;

export const UpdateChildSchema = AddChildSchema.partial();
export type UpdateChildInput = z.infer<typeof UpdateChildSchema>;

export const UpdateParentProfileSchema = z.object({
  country: z.string().trim().min(1).max(80).optional(),
  locale: z.string().trim().min(1).max(20).optional(),
  communicationPreferences: z
    .object({
      emailUpdates: z.boolean(),
      whatsappUpdates: z.boolean(),
    })
    .partial()
    .optional(),
});
export type UpdateParentProfileInput = z.infer<typeof UpdateParentProfileSchema>;

export const AddToShortlistSchema = z.object({
  tutorId: z.string().min(1),
});
export type AddToShortlistInput = z.infer<typeof AddToShortlistSchema>;

export const ChildResponseSchema = z.object({
  id: z.string(),
  name: z.string(),
  age: z.number().int(),
  grade: z.string(),
  notes: z.string().nullable(),
  createdAt: z.string(),
});
export type ChildResponse = z.infer<typeof ChildResponseSchema>;

export const ParentProfileResponseSchema = z.object({
  id: z.string(),
  userId: z.string(),
  country: z.string(),
  locale: z.string(),
  communicationPreferences: z.object({
    emailUpdates: z.boolean(),
    whatsappUpdates: z.boolean(),
  }),
  children: z.array(ChildResponseSchema),
  shortlistedTutorIds: z.array(z.string()),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type ParentProfileResponse = z.infer<typeof ParentProfileResponseSchema>;
